import React from 'react';
import Styles from './NissanMicra.module.css';
import Carousel from '../../../../components/Carousel/Carousel';
import { cars } from './Data';
import Hero from '../HeroForm/Hero';

const NissanMicra = () => {
  return (


    <div className={Styles.main_page}>
      <h2>Nissan Micra</h2>
      {/*Carousel*/}
      <div className={Styles.car_image}>
        <Carousel images={cars} />
      </div>


      
  <Hero selectedCar="Nissan Micra" />
    </div>

  );
}

export default NissanMicra;
